module.exports = __webpack_public_path__ + "static/media/features-bg.de8d27ab.jpg";